import {logClicksConstants} from "../constants/logClicksConstants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        recordsReturned: 0,
        totalRecords: 0
    },
    errorMsg: "",
    isLoading: false,
    clickId: "",
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false
};

const logClicksReducer = (state = initialState, action) => {
    switch (action.type) {
        case logClicksConstants.LOG_CLICKS_SET_IS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case logClicksConstants.LOG_CLICKS_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.records],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false
            };
        case logClicksConstants.LOG_CLICKS_LOADING:
            return {
                ...state,
                data: {
                    records: action?.result?.records,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false,
                rerender: false
            };
        case logClicksConstants.LOG_CLICKS_LOADING_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to load clicks report.',
                isLoading: false,
            };
        case logClicksConstants.LOG_CLICKS_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case logClicksConstants.LOG_CLICKS_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case logClicksConstants.LOG_CLICKS_UPDATE_CLICK_ID:
            return {
                ...state,
                clickId: action.clickId
            };
        case logClicksConstants.LOG_CLICKS_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        case logClicksConstants.LOG_CLICKS_RERENDER:
            return {
                ...state,
                rerender: true
            };
        default:
            return state;
    }
};

export default logClicksReducer;